import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { productDetailsImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DETAILS_SUPPORT_INFORMATION
        }
        question="What should I keep in mind while adding the Support Details?"
      />
    ),
    answer: (
      <div>
        Ensure that you provide your support{' '}
        <strong>email, phone number, or support URL(s)</strong> so buyers can
        reach out if needed. Describe what kind of support buyers can expect.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DETAILS_SUPPORT_INFORMATION
        }
        question="Do I need to add Learning Resources? Where is it visible?"
      />
    ),
    answer: (
      <div>
        <p>
          You can add links to whitepapers, product sheets, or other resources
          to help buyers learn more about your product. These resources will be
          displayed as hyperlinks on your listing page to help your buyers
          understand your product.
        </p>
        <div
          style={{
            backgroundColor: '#E5F6FD',
            padding: '10px',
            borderRadius: '4px',
            marginTop: '10px',
          }}
        >
          <p>
            <strong>Note:</strong> The URLs must be externally hosted and
            publicly accessible.
          </p>
        </div>
      </div>
    ),
  },
]

interface FlyoutProductDetailsSupportInformationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductDetailsSupportInformationFaqs: React.FC<
  FlyoutProductDetailsSupportInformationFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Support Information"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={productDetailsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
